import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { IPartnerShipNaCrud } from '../types'

import {
  PRIMARY_BUSINESS_MODEL_OPTIONS,
  UPDATED_PRIMARY_BUSINESS_MODEL_OPTIONS,
  usesUpdatedPrimaryBusinessModel,
} from './primaryBusinessModel'

// Also change on service onboarding in PortalIntegrationService.ts
const OwnershipStructure = [
  { label: 'Corporation', key: 'Corporation' },
  { label: 'Franchise', key: 'Franchise' },
  { label: 'Partnership', key: 'Partnership' },
  { label: 'Single member LLC', key: 'SingleMemberLLC' },
  {
    label: 'Individual sole proprietor',
    key: 'IndividualSoleProprietor',
  },
  { label: 'Other - Please enter below', key: 'Other' },
]

// Also change on service onboarding in PortalIntegrationService.ts
const Duration = [
  { label: 'Less than one year', key: 'Less' },
  { label: 'More than one year', key: 'More' },
  { label: 'Have not worked with any Distributor', key: 'HaveNotWorked' },
]

// Also change on service onboarding in PortalIntegrationService.ts
const PartnerRecruited = [
  { label: 'Yes', key: 'Yes' },
  { label: 'No', key: 'No' },
]

// Also change on service onboarding in PortalIntegrationService.ts
const AgentPartner = [
  { label: 'Yes', key: 'Yes' },
  { label: 'No', key: 'No' },
]

// Also change on service onboarding in PortalIntegrationService.ts
const OnlineByUser = [
  { label: 'Yes', key: 'Yes' },
  { label: 'No', key: 'No' },
]

// Also change on service onboarding in PortalIntegrationService.ts
const IsResidentailAddress = [
  { label: 'Yes', key: 'Yes' },
  { label: 'No', key: 'No' },
]

const composeSoleProprietor = () =>
  new Crud({
    fetcher: new Static([
      { label: 'Single member LLC', key: 'SingleMemberLLC' },
      {
        label: 'Individual sole proprietor',
        key: 'IndividualSoleProprietor',
      },
    ]),
    keyField: 'key',
  })

const composeDistributor = () =>
  new Crud({
    fetcher: new Static([
      {
        label: 'Yes, I sell to other resellers for reselling purposes',
        key: 'YesSellToOtherResellers',
      },
      { label: 'No, I only sell to end users', key: 'NoSellOnlyToEndUsers' },
    ]),
    keyField: 'key',
  })

export const PARTNERSHIP_NA_STATIC_DROPDOWNS_SOURCES: IPartnerShipNaCrud = {
  OwnershipStructure: new Crud({
    fetcher: new Static(OwnershipStructure),
    keyField: 'key',
  }),
  PrimaryBusinessModel: new Crud({
    fetcher: new Static(PRIMARY_BUSINESS_MODEL_OPTIONS),
    defaultPaging: {
      page: 0,
      pageSize: 20,
    },
    keyField: 'key',
  }),
  Duration: new Crud({
    fetcher: new Static(Duration),
    keyField: 'key',
  }),
  PartnerRecruited: new Crud({
    fetcher: new Static(PartnerRecruited),
    keyField: 'key',
  }),
  AgentPartner: new Crud({
    fetcher: new Static(AgentPartner),
    keyField: 'key',
  }),
  OnlineByUser: new Crud({
    fetcher: new Static(OnlineByUser),
    keyField: 'key',
  }),
  IsResidentailAddress: new Crud({
    fetcher: new Static(IsResidentailAddress),
    keyField: 'key',
  }),
  SoleProprietor: composeSoleProprietor(),
  IsDistributor: composeDistributor(),
}

const UPDATED_PARTNERSHIP_NA_DROPDOWNS_SOURCES: IPartnerShipNaCrud = {
  ...PARTNERSHIP_NA_STATIC_DROPDOWNS_SOURCES,
  PrimaryBusinessModel: new Crud({
    fetcher: new Static(UPDATED_PRIMARY_BUSINESS_MODEL_OPTIONS),
    defaultPaging: { page: 0, pageSize: 20 },
    keyField: 'key',
  }),
}

export const getPartnerShipNaDropdownsSources = (
  request?: Parameters<typeof usesUpdatedPrimaryBusinessModel>[0]
): IPartnerShipNaCrud =>
  usesUpdatedPrimaryBusinessModel(request)
    ? UPDATED_PARTNERSHIP_NA_DROPDOWNS_SOURCES
    : PARTNERSHIP_NA_STATIC_DROPDOWNS_SOURCES
